import React from 'react'

export type ChevronLeftIconProps = {
  color?: string
  className?: string
  width?: number
  height?: number
}

// Mirror of ChevronRightIcon so the chevron family stays consistent. Used for
// collapse/expand affordances, where a chevron (not an arrow) is the convention
// — an arrow-left reads as "go back", which is a different action.
export const ChevronLeftIcon = ({
  color = 'currentColor',
  className,
  width = 24,
  height = 24,
}: ChevronLeftIconProps) => (
  <svg
    aria-label='Chevron left'
    className={className}
    fill='none'
    height={height}
    role='img'
    viewBox='0 0 24 24'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M15 5L8 12L15 19' stroke={color} strokeWidth='2' />
  </svg>
)
